module.exports = __webpack_public_path__ + "assets/close-icon.2300c440.svg";